<ng-template #attendees let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Attendees for {{ selected_event.name }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row mb-3">
			<div class="col-12 text-end">
				<button class="btn btn-danger btn-sm" (click)="exportPdf()" [disabled]="sending">
					<i class="fa fa-file-pdf-o"></i> PDF
				</button>
				&nbsp;&nbsp;
				<button class="btn btn-success btn-sm" (click)="exportXls()" [disabled]="sending">
					<i class="fa fa-file-excel-o"></i> XLS
				</button>
			</div>
		</div>
		<div class="table_wrapper">
			<table class="table table-sm table-striped">
				<thead>
					<tr>
						<th>Order ID</th>
						<th>Customer</th>
						<th>Amount</th>
						<th>Paid By</th>
						<th>Seats</th>
						<th>Date Added</th>
						<th>Name</th>
						<th>Email</th>
						<th>Phone</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let attend of selected_event.history; let i = index">
						<tr>
							<td>{{attend.order_id}}</td>
							<td>{{attend.customer_id}}</td>
							<td>{{attend.amount}}</td>
							<td>{{attend.howpaid}}</td>
							<td>{{attend.seats}}</td>
							<td>{{attend.date_added}}</td>
							<td>{{attend.registrant}}</td>
							<td>{{attend.email}}</td>
							<td>{{attend.phone}}</td>
							<td><button class="btn btn-sm" (click)="removeReg(i);"><mat-icon>remove</mat-icon></button></td>
						</tr>
					</ng-container>
				</tbody>
			</table>
		</div>
	</div>
</ng-template>
<ng-template #setupModal let-modal>
	<div class="modal-header d-flex justify-content-between align-items-center">
		<div>
			<h4 *ngIf="selected_event" class="modal-title mb-0" id="modal-title">{{ selected_event.name }}</h4>
			<h4 *ngIf="!selected_event" class="modal-title mb-0" id="modal-title">New Event</h4>
		</div>
		<div class="d-flex gap-2">
			<button type="button" mat-stroked-button (click)="modal.dismiss('Cancel')" [disabled]="saving">
				<mat-icon>close</mat-icon>
				Cancel
			</button>
			<button type="button" mat-flat-button color="accent" (click)="saveEvent()" [disabled]="!eventForm.valid || saving">
				<mat-icon *ngIf="!saving">save</mat-icon>
				<mat-spinner *ngIf="saving" diameter="20" class="mr-2"></mat-spinner>
				{{ saving ? 'Saving...' : (selected_event ? 'Save Changes' : 'Create Event') }}
			</button>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
				<i class="fa fa-close"></i>
			</button>
		</div>
	</div>
	<div class="modal-body text-dark">
		<mat-tab-group #tabPanel mat-align-tabs="start" class="" color="accent">
			<form [formGroup]="eventForm">
				<mat-tab label="Basic Info">
					<div class="container-fluid mt-2">
						<!-- Event Information Section -->
						<div class="form-section">
							<h5 class="section-title">Event Information</h5>
							<div class="row">
								<div class="col-12">
									<mat-form-field appearance="outline">
										<mat-label>Event Name *</mat-label>
										<input matInput formControlName="name" placeholder="Enter event name" autocomplete="off">
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-6">
									<mat-form-field appearance="outline">
										<mat-label>Payment Code *</mat-label>
										<input matInput formControlName="code" placeholder="e.g., EDU2024" autocomplete="off">
									</mat-form-field>
								</div>
								<div class="col-6">
									<mat-form-field appearance="outline">
										<mat-label>URL Alias</mat-label>
										<input matInput formControlName="alias" placeholder="e.g., spring-workshop" autocomplete="off">
									</mat-form-field>
								</div>
							</div>
						</div>

						<!-- Date & Time Section -->
						<div class="form-section">
							<h5 class="section-title">Date & Time</h5>
							<div class="row">
								<div class="col-6">
									<mat-form-field appearance="outline">
										<mat-label>Start Date *</mat-label>
										<input matInput formControlName="date_start" [matDatepicker]="datestart" placeholder="Select start date">
										<mat-datepicker-toggle matSuffix [for]="datestart"></mat-datepicker-toggle>
										<mat-datepicker #datestart></mat-datepicker>
									</mat-form-field>
								</div>
								<div class="col-6">
									<mat-form-field appearance="outline">
										<mat-label>Start Time *</mat-label>
										<input matInput formControlName="start_time" [ngxTimepicker]="picker" placeholder="Select start time">
										<ngx-material-timepicker #picker></ngx-material-timepicker>
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-6">
									<mat-form-field appearance="outline">
										<mat-label>End Date *</mat-label>
										<input matInput formControlName="date_end" [matDatepicker]="dateend" placeholder="Select end date">
										<mat-datepicker-toggle matSuffix [for]="dateend"></mat-datepicker-toggle>
										<mat-datepicker #dateend></mat-datepicker>
									</mat-form-field>
								</div>
								<div class="col-6">
									<mat-form-field appearance="outline">
										<mat-label>End Time *</mat-label>
										<input matInput formControlName="end_time" [ngxTimepicker]="picker2" placeholder="Select end time">
										<ngx-material-timepicker #picker2></ngx-material-timepicker>
									</mat-form-field>
								</div>
							</div>
						</div>

						<!-- Capacity & Pricing Section -->
						<div class="form-section">
							<h5 class="section-title">Capacity & Pricing</h5>
							<div class="row">
								<div class="col-4">
									<mat-form-field appearance="outline">
										<mat-label>Total Seats *</mat-label>
										<input matInput formControlName="uses_total" placeholder="50" type="number">
									</mat-form-field>
								</div>
								<div class="col-4">
									<mat-form-field appearance="outline">
										<mat-label>Seats per Customer *</mat-label>
										<input matInput formControlName="uses_customer" placeholder="2" type="number">
									</mat-form-field>
								</div>
								<div class="col-4">
									<mat-form-field appearance="outline">
										<mat-label>Cost per Seat *</mat-label>
										<input matInput formControlName="discount" placeholder="25.00" type="number" step="0.01">
									</mat-form-field>
								</div>
							</div>
						</div>

						<!-- Settings Section -->
						<div class="form-section">
							<h5 class="section-title">Event Settings</h5>
							<div class="row">
								<div class="col-6">
									<mat-form-field appearance="outline">
										<mat-label>Region</mat-label>
										<mat-select formControlName="region">
											<mat-option value="">Select region</mat-option>
											<mat-option *ngFor="let r of eventregions;" value="r.id">{{r.name}}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-6">
									<mat-form-field appearance="outline">
										<mat-label>Customer Login Required</mat-label>
										<mat-select formControlName="logged">
											<mat-option value="0">No</mat-option>
											<mat-option value="1">Yes</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-6">
									<mat-form-field appearance="outline">
										<mat-label>Registration Status</mat-label>
										<mat-select formControlName="closed">
											<mat-option value="0">Open for Registration</mat-option>
											<mat-option value="1">Closed for Registration</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-6">
									<mat-form-field appearance="outline">
										<mat-label>Event Status</mat-label>
										<mat-select formControlName="status">
											<mat-option value="0">Disabled</mat-option>
											<mat-option value="1">Enabled</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
							</div>
						</div>
					</div>
				</mat-tab>
				<mat-tab label="More Details">
					<div class="container-fluid">
						<!-- Event Image Section -->
						<div class="form-section">
							<h5 class="section-title">Event Image</h5>
							<div class="row align-items-center">
								<div class="col-4">
									<div class="image-preview" *ngIf="selected_event?.thumb">
										<img [src]="selected_event.thumb" alt="Event preview" class="img-thumbnail">
									</div>
									<div class="no-image-placeholder" *ngIf="!selected_event?.thumb">
										<mat-icon class="placeholder-icon">image</mat-icon>
										<p class="placeholder-text">No image selected</p>
									</div>
								</div>
								<div class="col-8">
									<ngx-dropzone [multiple]="false" (change)="onSelect(selected_event.events_id, $event)" class="upload-zone">
										<ngx-dropzone-label>
											<div class="upload-content">
												<mat-icon class="upload-icon">cloud_upload</mat-icon>
												<h6>Upload Event Image</h6>
												<p class="upload-hint">Drag & drop or click to browse</p>
												<small class="upload-info">Supports JPG, PNG, GIF (Max 5MB)</small>
											</div>
										</ngx-dropzone-label>
									</ngx-dropzone>
								</div>
							</div>
						</div>
						<div class="form-section">
							<h5 class="section-title">Sell Sheet</h5>
							<div class="row align-items-center">
								<div class="col-4">
									<div class="image-preview" *ngIf="selected_event?.sell_sheet">
									{{selected_event?.sell_sheet}}
									</div>
									<div class="no-image-placeholder" *ngIf="!selected_event?.sell_sheet">
										<mat-icon class="placeholder-icon">image</mat-icon>
										<p class="placeholder-text">No file attached</p>
									</div>
								</div>
								<div class="col-8">
									<ngx-dropzone [multiple]="false" (change)="onSelect2(selected_event.events_id, $event)" class="upload-zone">
										<ngx-dropzone-label>
											<div class="upload-content">
												<mat-icon class="upload-icon">cloud_upload</mat-icon>
												<h6>Upload Sell Sheet</h6>
												<p class="upload-hint">Drag & drop or click to browse</p>
												<small class="upload-info">Supports PDF (Max 10MB)</small>
											</div>
										</ngx-dropzone-label>
									</ngx-dropzone>
								</div>
							</div>
						</div>
						<!-- Location & Contact Section -->
						<div class="form-section">
							<h5 class="section-title">Location & Contact</h5>
							<div class="row">
								<div class="col-6">
									<mat-form-field appearance="outline">
										<mat-label>Event Locations</mat-label>
										<mat-select multiple="true" formControlName="locations">
											<mat-option value="0">No specific location</mat-option>
											<mat-option *ngFor="let r of eventlocations;" [value]="r.events_locationid">{{r.location_name}}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-6">
									<mat-form-field appearance="outline">
										<mat-label>Contact Phone</mat-label>
										<input matInput formControlName="phone" mask="(000) 000-0000" [showMaskTyped]="true" placeholder="(555) 123-4567">
									</mat-form-field>
								</div>
							</div>
						</div>

						<!-- Event Staff Section -->
						<div class="form-section">
							<h5 class="section-title">Event Staff</h5>
							<div class="row">
								<div class="col-6">
									<mat-form-field appearance="outline">
										<mat-label>Artist/Instructor Name</mat-label>
										<input matInput formControlName="artist_name" placeholder="Enter artist or instructor name">
									</mat-form-field>
								</div>
								<div class="col-6">
									<mat-form-field appearance="outline">
										<mat-label>Event Host</mat-label>
										<input matInput formControlName="host" placeholder="Enter host name">
									</mat-form-field>
								</div>
							</div>
						</div>

						<!-- Description Section -->
						<div class="form-section">
							<h5 class="section-title">Event Description</h5>
							<div class="row">
								<div class="col-12">
									<mat-form-field appearance="outline">
										<mat-label>Short Description</mat-label>
										<textarea matInput formControlName="short_description" placeholder="Brief description for event listings (max 200 characters)" rows="3" maxlength="200"></textarea>
										<mat-hint align="end">{{eventForm.get('short_description')?.value?.length || 0}}/200</mat-hint>
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-12">
									<!--<label class="form-label">Detailed Description</label>
									<angular-editor formControlName="description" [config]="editorConfig" placeholder="Enter detailed event description, agenda, materials needed, etc."></angular-editor>
									-->
									<label for="description-editor" class="form-label small">Detailed Description</label>
									<app-wysiwyg-editor [input]="desc2Ctrl" (data)="updateForm(desc2Ctrl, $event)"></app-wysiwyg-editor>
								</div>
							</div>
						</div>
					</div>
				</mat-tab>
			</form>
			<mat-tab label="Recommended Products">
				<div class="container-fluid">
					<!-- Search Instructions -->
					<div class="form-section">
						<div class="alert alert-info d-flex align-items-center">
							<mat-icon class="me-2">info</mat-icon>
							<div>
								<strong>Add Recommended Products</strong><br>
								<small>Search for products to recommend to customers attending this event. Use the filters below to narrow down your search, then add products to the recommended list.</small>
							</div>
						</div>
					</div>

					<!-- Search Filters -->
					<div class="form-section">
						<h5 class="section-title">Search Products</h5>
						<div class="row">
							<div class="col-3">
								<mat-form-field appearance="outline">
									<mat-label>Brands</mat-label>
									<mat-select multiple="true" [formControl]="brandCtrl">
										<mat-option *ngFor="let r of brands;" [value]="r.manufacturer_id"><span [innerHTML]="r.name"></span></mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-3">
								<mat-form-field appearance="outline">
									<mat-label>Categories</mat-label>
									<mat-select multiple="true" [formControl]="categoryCtrl">
										<mat-option *ngFor="let r of categories;" [value]="r.categoryid"><span [innerHTML]="r.categorydescription"></span></mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-3">
								<mat-form-field appearance="outline">
									<mat-label>Product Lines</mat-label>
									<mat-select multiple="true" [formControl]="prodCtrl">
										<mat-option *ngFor="let r of productlines;" [value]="r.line_field"><span [innerHTML]="r.line_description"></span></mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-3">
								<mat-form-field appearance="outline">
									<mat-label>Description Search</mat-label>
									<input matInput [formControl]="descCtrl" placeholder="Search product descriptions">
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-12 text-center">
								<button mat-raised-button color="accent" (click)="getProducts()" class="search-btn" [disabled]="productsSearching">
									<mat-icon>search</mat-icon>
									<span *ngIf="!productsSearching">Search Products</span>
									<span *ngIf="productsSearching">Searching...</span>
								</button>
								<div class="mt-2" *ngIf="productsSearching">
									<mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
								</div>
							</div>
						</div>
					</div>

					<!-- Search Results -->
					<div class="form-section" *ngIf="picklist.length > 0">
						<h5 class="section-title">Search Results ({{picklist.length}} found)</h5>
						<div class="table-responsive">
							<table class="table table-hover">
								<thead class="table-light">
									<tr>
										<th>Item Number</th>
										<th>Description</th>
										<th width="120">Action</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let p of picklist;">
										<td><code>{{p.stockid}}</code></td>
										<td>{{p.description}}</td>
										<td>
											<button mat-stroked-button color="primary" (click)="addSingleProduct(p)" class="btn-sm">
												<mat-icon>add</mat-icon>
												Add
											</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="text-center mt-3">
							<button mat-flat-button color="accent" (click)="addProducts()" [disabled]="picklist.length === 0">
								<mat-icon>add_circle</mat-icon>
								Add All {{picklist.length}} Products
							</button>
						</div>
					</div>

					<!-- Recommended Products List -->
					<div class="form-section">
						<h5 class="section-title">
							Recommended Products 
							<span class="badge bg-primary ms-2 text-light" *ngIf="productlist.length > 0">{{productlist.length}}</span>
						</h5>
						
						<div *ngIf="productlist.length === 0" class="empty-state">
							<mat-icon class="empty-icon">inventory_2</mat-icon>
							<h6>No recommended products yet</h6>
							<p class="text-muted">Use the search filters above to find and add products to recommend for this event.</p>
						</div>

						<div *ngIf="productlist.length > 0" class="table-responsive">
							<table class="table table-hover">
								<thead class="table-light">
									<tr>
										<th>Item Number</th>
										<th>Description</th>
										<th width="120">Action</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let p of productlist;">
										<td><code>{{p.stockid}}</code></td>
										<td>{{p.description}}</td>
										<td>
											<button mat-stroked-button color="warn" (click)="removeProduct(p)" class="btn-sm">
												<mat-icon>remove</mat-icon>
												Remove
											</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</mat-tab>
		</mat-tab-group>
	</div>
</ng-template>
<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-6">
						<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> Education Events</h4>
						<p class="card-category text-right"></p>
					</div>
					<div class="card-body">
						<button mat-stroked-button (click)="addEvent()">
							<mat-icon>add</mat-icon>
							<span>Add Event</span>
						</button>
						
						&nbsp;
						<button class="btn btn-danger btn-sm" (click)="exportPdfMain()" [disabled]="sending">
							<i class="fa fa-file-pdf-o"></i> PDF
						</button>
						&nbsp;&nbsp;
						<button class="btn btn-success btn-sm" (click)="exportXlsMain()" [disabled]="sending">
							<i class="fa fa-file-excel-o"></i> XLS
						</button>
						<button mat-stroked-button class="btn btn-danger" (click)="deleteEvents()" style="float:right">
							<mat-icon>delete</mat-icon>
							<span>Delete Selected</span>
						</button>
						<div class="table-wrapper" *ngIf="!loading">
							<mat-paginator [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault"></mat-paginator>
							<div class="row filter-container align-items-center mb-3">
								<div class="col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Status</mat-label>
										<mat-select [formControl]="statusCtrl">
											<mat-option value="both">Both</mat-option>
											<mat-option value="enabled">Enabled</mat-option>
											<mat-option value="disabled">Disabled</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-9">
									<mat-form-field appearance="outline" class="w-100 text-right">
										<mat-label>Search</mat-label>
										<input matInput placeholder="Search Events" [formControl]="searchCtrl" class="text-right" (keydown.enter)="$event.preventDefault()">
										<button mat-icon-button matSuffix (click)="filterEvents()">
											<mat-icon>search</mat-icon>
										</button>
										<mat-progress-bar mode="indeterminate" color="accent" *ngIf="searching"></mat-progress-bar>
									</mat-form-field>
								</div>
							</div>


							<table class="table table-sm table-striped table-fixed">
								<thead>
									<tr>
										<th class="noprint"></th>
										<th class="noprint"></th>
										<th scope="col" (click)="sortTable('name')">Event Name <mat-icon>{{ getSortIcon('name') }}</mat-icon></th>
										<th class="text-center" (click)="sortTable('host')">Host <mat-icon>{{ getSortIcon('host') }}</mat-icon></th>
										<th class="text-center" (click)="sortTable('city')"> City <mat-icon>{{ getSortIcon('city') }}</mat-icon></th>
										<th class="text-center" (click)="sortTable('location_name')"> Location <mat-icon>{{ getSortIcon('location_name') }}</mat-icon></th>
										<th class="text-center">Seats</th>
										<th class="text-center" scope="col" (click)="sortTable('registered')">Registered <mat-icon>{{ getSortIcon('registered') }}</mat-icon></th>
										<th class="text-center" (click)="sortTable('sortdatestart')">Date Start <mat-icon>{{ getSortIcon('sortdatestart') }}</mat-icon></th>
										<th class="text-center" (click)="sortTable('sortdateend')">Date End <mat-icon>{{ getSortIcon('sortdateend') }}</mat-icon></th>
										<th class="text-center"> Cost / Seat </th>
										<th class="text-center"> Payment Code </th>
										<th class="text-center" (click)="sortTable('status')">Status <mat-icon>{{ getSortIcon('status') }}</mat-icon></th>
										<th class="text-center" scope="col" (click)="sortTable('closed')">Open / Closed  <mat-icon>{{ getSortIcon('closed') }}</mat-icon></th>
										
										
										
										
										
										
										
										
									</tr>
								</thead>
								<tbody>
									<tr class="datarow" *ngFor="let item of dataObs | async">
										<td class="noprint">
											<label class="custom-checkbox">
												<input type="checkbox" [checked]="isChecked(item)" (change)="onCheckboxChange($event, item)">
												<span class="checkmark"></span>
											</label>
										</td>
										<td class="noprint">
											<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Actions">
												<mat-icon>more_vert</mat-icon>
											</button>
											<mat-menu #menu="matMenu">
												<button mat-menu-item (click)="editEvent(item.events_id)">
													<mat-icon>edit</mat-icon>
													<span>Edit Event</span>
												</button>
												<button mat-menu-item (click)="deleteEvent(item.events_id)" *ngIf="item.registered == 0">
													<mat-icon>remove</mat-icon>
													<span>Remove Event</span>
												</button>
												<mat-divider *ngIf="item.registered > 0"></mat-divider>
												<button mat-menu-item *ngIf="item.registered > 0" (click)="viewAttendees(item.events_id)">
													<mat-icon>person</mat-icon>
													<span>View Attendees</span>
												</button>
												<mat-divider *ngIf="item.waitlisted > 0"></mat-divider>
												<button mat-menu-item *ngIf="item.waitlisted > 0" (click)="viewWaitlisted(item.events_id)">
													<mat-icon>front_hand</mat-icon>
													<span>View Waitlisted</span>
												</button>
											</mat-menu>
										</td>
										<td class="text-center">{{ item.name }}</td>
										<td>{{ item.host }}</td>
										<td class="text-center">{{ item.city }}</td>
										<td class="text-center">{{ item.location_name }}</td>
										<td class="text-center">{{ item.total_remaining }} / {{ item.total_seats }}</td>	
										<td class="text-center">{{ item.registered }}</td>									
										<td class="text-center">{{ item.date_start }}</td>
										<td class="text-center">{{ item.date_end }}</td>
										<td class="text-center">{{ item.discount | currency}}</td>
										<td class="text-center">{{ item.code }}</td>
										<td class="text-center">{{ item.status }}</td>
										<td class="text-center" [ngClass]="{'red': item.closed == 1, 'green' : item.closed != 1}">
											{{ item.closed == 1 ? 'Closed' : 'Open' }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="table" *ngIf="!loading && !eventlist.length">
							<h4 class="text-center"> No Results</h4>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div #print_table_pdf style="display:none">
			<h2>{{selected_event.name}} - Attendee List</h2>
			<table class="table">
				<thead>
					<tr>
						<th style="text-align: center;">Order ID</th>
						<th style="text-align: center;">Customer</th>
						<th style="text-align: right;">Amount</th>
						<th style="text-align: center;">Paid With</th>
						<th style="text-align: center;">Seats</th>
						<th style="text-align: left;">Name</th>
						<th style="text-align: left;">Email</th>
						<th style="text-align: center;">Phone</th>
						<th style="text-align: center;">Date Added</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let attend of selected_event.history">
						<td style="text-align: center;">{{attend.order_id}}</td>
						<td style="text-align: center;">{{attend.customer_id}}</td>
						<td style="text-align: right;">{{attend.amount | currency}}</td>
						<td style="text-align: center;">{{attend.howpaid}}</td>
						<td style="text-align: center;">{{attend.seats}}</td>
						<td style="text-align: left;">{{attend.registrant}}</td>
						<td style="text-align: left;">{{attend.email}}</td>
						<td style="text-align: center;">{{attend.phone}}</td>
						<td style="text-align: center;">{{attend.date_added}}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div #print_table_xlsx style="display:none">
			<table>
				<thead>
					<tr>
						<th>Order ID</th>
						<th>Customer</th>
						<th>Amount</th>
						<th>Paid With</th>
						<th>Seats</th>
						<th>Name</th>
						<th>Email</th>
						<th>Phone</th>
						<th>Date Added</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let attend of selected_event.history">
						<td>{{attend.order_id}}</td>
						<td>{{attend.customer_id}}</td>
						<td>{{attend.amount | currency}}</td>
						<td>{{attend.howpaid}}</td>
						<td>{{attend.seats}}</td>
						<td>{{attend.registrant}}</td>
						<td>{{attend.email}}</td>
						<td>{{attend.phone}}</td>
						<td>{{attend.date_added}}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div #print_table_main style="display:none;">
			<table class="table table-sm table-striped table-fixed">
								<thead>
									<tr>
										<th scope="col">Event Name</th>
										<th class="text-center" >Host </th>
										<th class="text-center"> City </th>
										<th class="text-center" > Location</th>
										<th class="text-center">Seats</th>
										<th class="text-center" >Registered</th>
										<th class="text-center">Date Start</th>
										<th class="text-center">Date End </th>
										<th class="text-center"> Cost / Seat </th>
										<th class="text-center"> Payment Code </th>
										<th class="text-center">Status</th>
										<th class="text-center">Open / Closed</th>
									</tr>
								</thead>
								<tbody>
									<tr class="datarow" *ngFor="let item of dataObs | async">
										<td class="text-center">{{ item.name }}</td>
										<td>{{ item.host }}</td>
										<td class="text-center">{{ item.city }}</td>
										<td class="text-center">{{ item.location_name }}</td>
										<td class="text-center">{{ item.total_remaining }} / {{ item.total_seats }}</td>	
										<td class="text-center">{{ item.registered }}</td>									
										<td class="text-center">{{ item.date_start }}</td>
										<td class="text-center">{{ item.date_end }}</td>
										<td class="text-center">{{ item.discount }}</td>
										<td class="text-center">{{ item.code }}</td>
										<td class="text-center">{{ item.status }}</td>
										<td class="text-center" [ngClass]="{'red': item.closed == 1, 'green' : item.closed != 1}">
											{{ item.closed == 1 ? 'Closed' : 'Open' }}
										</td>
									</tr>
								</tbody>
							</table>
		</div>
	</div>